import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const ButtonLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`

export const Anchor = styled.a`
  text-decoration: none;
  width: 100%;
`
